import styled from 'styled-components/macro';

export const mobileOptinText =
  'Yes, I want to receive SMS messages for webinars and other professional learning opportunities.';

export const mobileLoginText =
  'You can use your mobile number to sign in or reset your password with a one-time code sent to your phone';

export const MobileLoginText = styled.div`
  font-size: 0.75rem;
  font-weight: 500;
  ${props => props.$marginTop && `margin-top: ${props.$marginTop};`}
  ${props => props.$marginBottom && `margin-bottom: ${props.$marginBottom};`}
`;
